import { Link } from 'react-router-dom';
import { useReveal } from '../motion';
import { items, safeHref, safeImage, str } from './types';

/**
 * Dvoubarevný nadpis „Pro Psy": první slovo tmavě, zbytek (název mazlíčka)
 * značkovou akcentní barvou – jako na petcenteru. Bez mezery se vrátí celý.
 */
function splitTitle(title: string) {
  const space = title.indexOf(' ');
  if (space === -1) return title;
  return (
    <>
      {title.slice(0, space)}
      <span className="promo-title-accent"> {title.slice(space + 1)}</span>
    </>
  );
}

/**
 * Mozaika kampani.
 *
 * Prvni dlazdice je siroka, zbytek se rovna do mrizky – jedna vec ma
 * dostat prednost, jinak je z toho jen stena stejne dulezitych sdeleni,
 * ze ktere si zakaznik nevybere nic.
 */
export function PromoTilesBlock({ config }: { config: Record<string, unknown> }) {
  const { ref, className } = useReveal<HTMLElement>();
  const title = str(config, 'title');
  const tiles = items(config, 'items');

  if (tiles.length === 0) return null;

  return (
    <section ref={ref} className={`block promo-tiles ${className}`}>
      {title !== '' && <h2 className="block-title">{title}</h2>}

      <div className="promo-grid">
        {tiles.map((tile, index) => {
          const href = safeHref(tile, 'href');
          const image = safeImage(tile, 'imageUrl');
          const tone = str(tile, 'tone', 'soft');
          const cta = str(tile, 'ctaLabel');
          const inner = (
            <>
              {image !== null && <img className="promo-image" src={image} alt="" loading="lazy" />}
              <span className="promo-copy">
                <strong>{splitTitle(str(tile, 'title'))}</strong>
                <span className="promo-text">{str(tile, 'text')}</span>
              </span>
              {cta !== '' && (
                <span className="promo-cta">
                  {cta} <span aria-hidden="true">→</span>
                </span>
              )}
            </>
          );

          const classes = `promo-tile promo-${tone}${index === 0 ? ' is-wide' : ''}`;

          // Dlaždice bez odkazu je jen sdělení, ne past na klikání.
          if (href === null) {
            return (
              <div key={index} className={classes} style={{ '--i': index } as React.CSSProperties}>
                {inner}
              </div>
            );
          }

          if (href.startsWith('#')) {
            return (
              <a
                key={index}
                href={href}
                className={classes}
                style={{ '--i': index } as React.CSSProperties}
              >
                {inner}
              </a>
            );
          }

          return (
            <Link
              key={index}
              to={href}
              className={classes}
              style={{ '--i': index } as React.CSSProperties}
            >
              {inner}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
